import React from "react"
import { useTranslation } from "react-i18next"

import { IconSize } from "shared/types/Icon"
import { Button, ButtonVariant } from "shared/ui/buttons/Button"
import { IconName } from "shared/ui/icon/__generated__/IconName"

import { useProductQuickInfosContext } from "./ProductQuickInfosContext"

export const ProductQuickInfosCopyToClipboard = React.memo(() => {
  const { t } = useTranslation()
  const { copyToClipboard } = useProductQuickInfosContext()

  return (
    <Button
      variant={ButtonVariant.SECONDARY}
      onClick={copyToClipboard}
      label={t("General.CopyToClipboard")}
      icon={IconName.DUPLICATE}
      iconSize={IconSize.SMALL}
      className="btn--borderless btn--bleed"
    />
  )
})

ProductQuickInfosCopyToClipboard.displayName =
  "ProductQuickInfos.CopyToClipboard"
